// extracted by mini-css-extract-plugin
export default {"container":"So-z","ratingLayout":"To-z","ratingLabel":"Uo-z","nonInteractiveRatingLabel":"Vo-z"};